export default __webpack_public_path__ + "images/0c024fd592739181426f95aeb5bfc9df.png";